import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import { fetchPatientSurveys } from 'store/reports/actions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchPatientSurveys.STARTED]: handleActionStart,
  [fetchPatientSurveys.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload || [];
  },

  [fetchPatientSurveys.FAILED]: handleActionError,
});
